import EvaluacionDisciplinaOperativaAdapter from '../adapters/EvaluacionDisciplinaOperativa.adapter'

export default class UpdateEvaluacionDisciplinaOperativaUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacion) {
    try {
      const dto = EvaluacionDisciplinaOperativaAdapter.toDto(evaluacion)
      await this.#repository.update(dto)
    } catch (error) {
      throw new Error(`Failed to execute UpdateEvaluacionDisciplinaOperativaUseCase: ${error.message}`)
    }
  }
}
